import * as StoreTypes from "../DataTypes/storeTypes";
import * as ActionGenerics from "../../Common/actionGenerics";
import * as ActionTypes from "../Actions/actionTypes";
import * as ProviderTypes from "../DataTypes/providerTypes";

export const providers = (
    state: ProviderTypes.IProvider[],
    action: ActionGenerics.IAction<ActionTypes.Actions>
): ProviderTypes.IProvider[] => {
    switch (action.type) {
        case ActionTypes.Actions.UpdateProviders: {
            const data = action as ActionGenerics.IParamAction<ActionTypes.Actions, ProviderTypes.IProvider[]>;

            return data.parameter;
        }

        default:
            return state;
    }
};
